import { Injectable } from '@angular/core';
import { IRowData } from '../../../shared/models/list-models';
import { find, result, round } from 'lodash';
import { IBarGraphData, IStackedBarGraphData, IxAxisRotation } from './../../models/viz-models';

@Injectable()
export class VizDataService {
  formatBarGraphData(rowData: IRowData[][], vizGroupingKey: string): IBarGraphData[] {
    const data = [];
    [...rowData].forEach(row => {
      let group = result(find(row, { columnKey: 'STUB' }), 'data');
      let value = result(find(row, { columnKey: vizGroupingKey }), 'data');
      data.push({ group, value });
    });
    return data;
  }

  formatStackedBarPercentData(
    rowData: IRowData[][],
    vizStackedBarKeys: string[],
    vizGroupingKey: string,
  ): IStackedBarGraphData[] {
    const data = [];
    rowData.map(row => {
      let stackedDataObj = {};
      const group: string = result(find(row, { columnKey: 'STUB' }), 'data');
      // add vizGroupingKey to use for sort.
      const value: string = result(find(row, { columnKey: vizGroupingKey }), 'data');
      const total: number = result(find(row, { columnKey: 'TOTAL' }), 'data');
      stackedDataObj = { ...stackedDataObj, group, [vizGroupingKey]: value };
      vizStackedBarKeys.map(stackedKey => {
        const data: number = result(find(row, { columnKey: stackedKey }), 'data');
        const percent = round((data / total) * 100, 2);
        stackedDataObj = { ...stackedDataObj, ...{ [stackedKey]: percent } };
      });
      data.push(stackedDataObj);
    });
    return data;
  }

  formatStackedBarCountData(
    rowData: IRowData[][],
    vizStackedBarKeys: string[],
    vizGroupingKey: string,
  ): IStackedBarGraphData[] {
    const data = [];
    rowData.map(row => {
      let stackedDataObj = {};
      const group: string = result(find(row, { columnKey: 'STUB' }), 'data');
      // add vizGroupingKey to use for sort.
      const value: string = result(find(row, { columnKey: vizGroupingKey }), 'data');
      stackedDataObj = { ...stackedDataObj, group, [vizGroupingKey]: value };
      vizStackedBarKeys.map(stackedKey => {
        const count: number = result(find(row, { columnKey: stackedKey }), 'data');
        stackedDataObj = { ...stackedDataObj, ...{ [stackedKey]: count } };
      });
      data.push(stackedDataObj);
    });
    return data;
  }

  sortBarGraphData(data: IBarGraphData[]): IBarGraphData[] {
    const sortedData = data.sort((a, b) => {
      return b.value - a.value;
    });
    return sortedData;
  }

  // maintain same sort as bar graphs. sort greatest to least based on viz grouping key.(cmac)
  sortStackedBarData(data: IStackedBarGraphData[], vizGroupingKey: string): IStackedBarGraphData[] {
    const sortedData = data.sort((a, b) => {
      return b[vizGroupingKey] - a[vizGroupingKey];
    });
    return sortedData;
  }

  getLabelRotation(data: IBarGraphData[] | IStackedBarGraphData[]): IxAxisRotation {
    const groupCount = data.length;
    const maxLength = 8;
    const labelAnchor = groupCount > maxLength ? 'start' : 'middle';
    const rotation = groupCount > maxLength ? 15 : 0;
    const axisRotation = { labelAnchor, rotation };
    return axisRotation;
  }
}
